<template>
    <div>
        <b-card
            v-if="show"
            bg-variant="light"
            no-body
            class="text-dark p-2 mb-3 shadow-sm"
        >
            <b-link
                title="Accéder à la fiche client"
                @click="goToClientHome(notice.client_uuid)"
            >
                <p class="notice-client">
                    {{ notice.client_name }}
                    <span class="float-right">{{ notice.rev_initials }}</span>
                </p>
            </b-link>
            <p class="notice-created">{{ notice.jdc_notice_date_for_human }}</p>
            <hr class="mb-1 mt-1" />
            <p class="notice-description">
                {{ notice.title }}
                <b-link
                    v-if="!hasComments"
                    :title="commentsTitle"
                    @click="openModal"
                >
                    <span class="small text-secondary">
                        <i
                            class="fas fa-fw fa-plus fa-pull-right"
                            data-fa-transform="down-6"
                        ></i>
                    </span>
                </b-link>
            </p>
            <b-link
                v-if="hasComments"
                :title="commentsTitle"
                @click="openModal"
            >
                <span class="notice-comment">
                    {{ lastComment }}
                </span>
            </b-link>
            <div class="row mt-2">
                <div class="col-6 pr-1">
                    <b-link
                        :href="notice.jdc_link"
                        target="_blank"
                        class="btn btn-sm btn-block btn-primary"
                        title="Afficher le détail de l'ARS"
                    >
                        <i class="far fa-eye fa-fw"></i> Je Déclare
                    </b-link>
                </div>
                <div class="col-6 pl-1">
                    <b-button
                        variant="success"
                        size="sm"
                        block
                        @click="confirmProcess"
                    >
                        <i class="far fa-check fa-fw"></i> Traiter
                    </b-button>
                </div>
            </div>
        </b-card>
        <b-modal
            :id="'comments-modal-id' + notice.id"
            :key="'comments-modal-key' + notice.id"
            :title="
                'Commentaires sur l\'ARS ' +
                notice.ars_number +
                ' pour le client ' +
                notice.client_name
            "
            hide-footer
            centered
            size="lg"
        >
            <div v-if="showComments">
                <loading v-if="loading" />
                <div v-if="hasComments">
                    <comment-handler
                        v-for="comment in fullComments"
                        :key="'ch' + comment.id"
                        :comment="comment"
                    />
                </div>
                <div v-else>
                    <b-card
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="comment-description">
                            Aucun commentaire n'a été rédigé sur cet ARS
                        </p>
                    </b-card>
                </div>
                <b-button variant="success" size="sm" @click="hideComments">
                    <i class="fas fa-fw fa-plus"></i> Ajouter un commentaire
                </b-button>
            </div>
            <div v-else>
                <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    size="sm"
                    rows="3"
                    max-rows="6"
                    class="mb-2"
                ></b-form-textarea>
                <b-button variant="secondary" size="sm" @click="hideForm">
                    <i class="fas fa-fw fa-arrow-alt-left"></i> Retour aux
                    commentaires
                </b-button>
                <b-button variant="success" size="sm" @click="storeComment">
                    <i class="fas fa-fw fa-save"></i> Enregistrer
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'JdcCard',

    props: {
        notice: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            show: true,
            fullComments: [],
            loading: true,
            showComments: true,
            form: {},
        }
    },

    computed: {
        commentsTitle() {
            return this.hasComments
                ? 'Afficher les commentaires'
                : 'Ajouter un commentaire'
        },

        hasComments() {
            return this.fullComments.length > 0
        },

        lastComment() {
            return this.hasComments
                ? this.fullComments[0].description
                : 'Aucun commentaire'
        },
    },

    async created() {
        this.fullComments = this.notice.fullComments.data
    },

    methods: {
        confirmProcess() {
            this.$bvModal
                .msgBoxConfirm("Etes-vous sûr·e d'avoir traité cet ARS' ?", {
                    title: "Traitement d'un ARS",
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'OUI',
                    cancelTitle: 'NON',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.processArs()
                    }
                })
                .catch(() => {
                    // An error occurred
                })
        },

        async processArs() {
            try {
                await this.$axios.post(`/jdc/process/${this.notice.id}`)
                this.show = false
            } catch (error) {
                error.log(error)
            }
        },

        async openModal() {
            this.$bvModal.show(`comments-modal-id${this.notice.id}`)
            await this.getComments()
        },

        async getComments() {
            try {
                this.loading = true
                const response = await this.$axios.get(
                    `/clients/${this.notice.client_id}/history/${this.notice.id}`
                )
                this.fullComments = response.data.data
                this.loading = false
            } catch (error) {
                error.log(error)
            }
        },

        async storeComment() {
            try {
                this.form.client_id = this.notice.client_id
                this.form.jdc_notice_id = this.notice.id
                this.form.type = 'jdc'
                await this.$axios.post('/clientEvents/event', this.form)
                await this.getComments()
                this.hideForm()
            } catch (error) {
                error.log(error)
            }
        },

        hideComments() {
            this.showComments = false
        },

        hideForm() {
            this.showComments = true
        },

        goToClientHome(uuid) {
            window.location.href = `pilotage-activite/clients/${uuid}/accueil`
        },
    },
}
</script>

<style scoped>
.notice-client {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
}

.notice-description {
    margin-bottom: 0;
}

.notice-created {
    font-size: 11px;
    margin-bottom: 0;
    font-style: italic;
}

.notice-comment {
    font-size: 12px;
    margin-bottom: 0;
    font-style: italic;
}
</style>
